module.exports = __webpack_public_path__ + "img/step5-complete.457de9e2.png";